export default {
    apiKey: "AIzaSyCze7msqmoInmZ2d_5eeAwJxIiEPFb3syI",
    authDomain: "ares-uat2-app.firebaseapp.com",
    projectId: "ares-uat2-app",
    storageBucket: "ares-uat2-app.appspot.com",
    messagingSenderId: "912511282336",
    appId: "1:912511282336:web:683b23bb033ceeea576dc5",
    measurementId: "G-95Z9J25QL4"
};